import React from 'react'
export default function AccessibilityPolicy() {
    return (
        <div>
            <h4>Accessibility Policy</h4>
            <p>Covr Financial Technology commits to designing our technology products with a strong focus on web site accessibility. Applicable accessibility standards will act as technical guidance during development and maintenance of our service platforms.</p>
            <h5 className="link-color"><u>Contact Us</u></h5>
            <p>If you have any questions or complaints concerning this Privacy Policy or our handling of your Personal Information (other than with respect to California Privacy Rights) you may contact us at <a href="mailto:privacy@covrtech.com">privacy@covrtech.com</a> or write to us at: Covr Financial Technologies, LLC, 401 W. Front Street, Boise, ID 83702, Attn: Privacy Officer.</p>
            <p>If you have any questions concerning California Privacy Rights you may contact us at <a href="mailto:californiaprivacy@covrtech.com">californiaprivacy@covrtech.com</a> or write to us at: Covr Financial Technologies, LLC, 401 W. Front Street, Boise, ID 83702, Attn: California Privacy Officer.</p>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Disclosure/AccessibilityPolicy.js